import React from 'react';
import { Button } from '@mui/material';
import { useAuth } from '../../contexts/AuthContext';

/** `returnTo` is the in-app path to come back to after signing in. */
const LoginButton = ({ children, returnTo = null, ...props }) => {
  const { login } = useAuth();

  return (
    <Button 
      variant="contained" 
      color="primary" 
      onClick={() => login(returnTo)}
      {...props}
    >
      {children || 'Log In'}
    </Button>
  );
};

export default LoginButton;
